<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>&nbsp;&nbsp;&nbsp;Report Category List</h2>
    </div>
</div>

<div class="field col-2 md:col-2 mb-2">
    <button pButton
            type="button"
            label="Create Report Category"
            pTooltipPosition="true"
            icon="pi pi-book"
            class="ui-button-plain buttonWidth-14 GreyButton"
            (click)="onAddReportCategory()"></button>
</div>
<p-table *ngIf="reportCategories_new"
         [columns]="cols"
         [value]="reportCategories_new.data"
         selectionMode="single"
         dataKey="reportCategoryId"
         [(selection)]="selectedCategories"
         [paginator]="showRecords"
         [rows]="rows">
    <ng-template pTemplate="header" let-columns>
        <tr *ngIf="showRecords == true">
            <th *ngFor="let col of columns"
                [pSortableColumn]="col.field"
                class="field col-10 md:col-10">
                {{ col.header }}
                <p-sortIcon [field]="col.field"
                            ariaLabel="Activate to sort"
                            ariaLabelDesc="Activate to sort in descending order"
                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th class="col-2 md:col-2" style="text-align: center">Actions</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
            <td>
                {{ rowData['reportCategoryName'] }}
            </td>

            <td style="text-align: center !important">
                <button pButton
                        type="button"
                        icon="pi pi-pencil"
                        pTooltip="Edit"
                        class="p-button-link"
                        (click)="onEditDTO(rowData)"></button>
                <button pButton
                        type="button"
                        icon="pi pi-trash"
                        pTooltip="Delete"
                        class="p-button-link p-button-danger ml-3"
                        (click)="dropcategory($event, rowData['reportCategoryId'])"></button>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <div class="w-12 bg-white">
            <div class="" style="text-align: center">
                <img _ngcontent-ng-c683320295="" class="profile-image" style="border-radius: 50%; width: 10rem; padding-top: 1rem" src="assets/imagesNew/table_error.png" />
            </div>
            <hr style="margin-bottom: 0.5rem" />
            <div class="" style="text-align: center; font-size: larger; color: #1d428f">
                <i>No records found</i>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="paginatorleft" let-state>

        <span *ngIf="state.totalRecords > pageSize">
            Showing {{ state.page * state.rows + 1 }} to
            {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
        </span>
    </ng-template>
</p-table>

<p-dialog header="{{ reportCategoryOperation }} Report Category "
          *ngIf="update"
          [(visible)]="update"
          [modal]="true"
          [responsive]="true"
          [style]="{ minWidth: '400px' }"
          [minY]="70"
          [maximizable]="true"
          [baseZIndex]="10000">
    <div class="card">
        <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-12">
                <span class="p-float-label">
                    <input type="text"
                           pInputText
                           [(ngModel)]="addEditReportCategoryDto.reportCategoryName"
                           id="cattext"
                           class="textboxBorder-1 col-12 md:col-12" />
                    <label for="cattext" class="f1">
                        <span class="required-asteric"> * </span> Enter Category
                        Name
                    </label>
                </span>
            </div>

            <div class="field col-12 md:col-12">
                <span class="p-float-label">

                    <p-multiSelect [options]="rolesList"
                                   [(ngModel)]="selectedRoles"
                                   optionLabel="roleName"
                                   contenteditable="false"
                                   optionValue="roleId"
                                   [showToggleAll]="true"
                                   selectedItemsLabel="{0} Role(s) selected"
                                   placeholder="Choose Role"
                                   appendTo="body">
                       
                    </p-multiSelect>

               <label for="ddlRole" class="f1">
                <span class="required-asteric"> * </span> Role
                    </label>
                </span>
            </div>

            <div class="field">
                <button pButton
                        type="submit"
                        icon="pi pi-save"
                        (click)="saveReportCategoryNewDTO()"
                        label="Save"
                        class="p-button-plain ml-9"></button>
            </div>
        </div>
    </div>
</p-dialog>
